export const GET_CRITERIA_TAB = ' GET_CRITERIA_TAB';
